import { MarketingHeader } from '@/components/marketing/MarketingHeader';
import { MarketingFooter } from '@/components/marketing/MarketingFooter';
import { MobileStickyCta } from '@/components/landing-v2/MobileStickyCta';
import { HomeHero } from '@/components/home/HomeHero';
import { IntegrationLogos } from '@/components/home/IntegrationLogos';
import { AgentDefinition, FeatureBento, ProblemSection, ScoreExplainer, StatementReveal } from '@/components/home/StorySections';
import { WorkflowStory } from '@/components/home/WorkflowStory';
import { AssistantSection } from '@/components/home/AssistantSection';
import { ComparisonSection, ControlSection, DeskSolutions, FaqSection, FinalCta, PricingSection, ScreeningCostCalculator } from '@/components/home/ConversionSections';
import { HomeStructuredData } from '@/components/seo/HomeStructuredData';
import { HOME_META } from '@/data/marketingContent';
import { useSEO } from '@/hooks/useSEO';

export default function HomeV2() {
  useSEO({ title: HOME_META.title, description: HOME_META.description, canonicalUrl: HOME_META.canonical });
  return (
    <div className="min-h-screen bg-bv-base text-bv-ink">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-3 focus:top-3 focus:z-[100] focus:rounded-md focus:bg-bv-blue focus:px-3 focus:py-2 focus:text-bv-ondeep">Skip to content</a>
      <HomeStructuredData />
      <MarketingHeader />
      <main id="main">
        <HomeHero />
        <IntegrationLogos />
        <ProblemSection />
        <AgentDefinition />
        <AssistantSection />
        <WorkflowStory />
        <FeatureBento />
        <ScoreExplainer />
        <StatementReveal />
        <ScreeningCostCalculator />
        <ControlSection />
        <DeskSolutions />
        <ComparisonSection />
        <PricingSection />
        <FaqSection />
        <FinalCta />
      </main>
      <MarketingFooter />
      <MobileStickyCta />
    </div>
  );
}
